module.exports = __webpack_public_path__ + "img/Managers.bf0381f3.svg";